import { BaseElement } from 'base';

class DesignGuideTooltip extends BaseElement {
  onConnect() {
    this.#bindSpecimens();
  }

  async #bindSpecimens() {
    await customElements.whenDefined('info-tooltip');
    if (!this.isConnected) return;

    this.qa('info-tooltip').forEach(tooltip =>
      this.cleanup(tooltip.onToggle(state => this.#report(state)))
    );
  }

  #report({ id, open, reason }) {
    const log = this.q('[data-tooltip-log]');
    if (log)
      log.textContent = `${id}: ${open ? 'opened' : 'closed'} (${reason})`;
  }
}

if (!customElements.get('design-guide-tooltip')) {
  customElements.define('design-guide-tooltip', DesignGuideTooltip);
}
